import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IDashboard } from "../../features/Dashboard/interface";
import { useAuth } from "../helper";

interface DashboardParams {
  from?: string | Date;
  to?: string | Date;
}

export const useDashboardData = (params: DashboardParams) => {
  const { selectedIntegration } = useAuth();
  return useQuery({
    queryKey: ["dashboard", params, selectedIntegration?.value],
    queryFn: async () => {
      const response = await httpService.get<IDashboard>(
        API_CONFIG.path.dashboard,
        {
          from: dayjs(params.from).format("YYYY-MM-DD"),
          to: dayjs(params.to).format("YYYY-MM-DD"),
          tracking_id: selectedIntegration?.value || "",
        }
      );
      return response;
    },
    // Only fetch data if an integration is selected
    enabled: !!selectedIntegration,
  });
};
